import "./SellYourHouseFast.module.css";
import Header from "@/reusable_sections/Header";
import Offer from "./sections/Offer";
import Process from "./sections/Process";
import Benefits from "./sections/Benefits";
import Footer from "@/reusable_sections/Footer";
export default function SellYourHouseFastPage() {
  return <div>
      <Header />
      <Offer />
      <Process />
      <Benefits />
      <Footer />
    </div>;
}